import { Reveal, SectionHeading } from "./Reveal";
import { useLanguage } from "@/i18n";
import { Scale, Code2 } from "lucide-react";

export default function Timeline() {
    const { t } = useLanguage();

    return (
        <section id="esperienza" data-testid="timeline-section" className="relative scroll-mt-20">
            <div className="mx-auto max-w-7xl px-6 py-24 lg:px-10 lg:py-32">
                <SectionHeading
                    chapter={t.experience.chapter}
                    eyebrow={t.experience.eyebrow}
                    title={t.experience.title}
                    description={t.experience.description}
                    testid="timeline-heading"
                />

                <div className="grid gap-14 lg:grid-cols-3">
                    <ol className="relative ml-3 border-l border-navy-600 lg:col-span-2 lg:ml-6">
                        {t.experience.items.map((item, i) => (
                            <Reveal key={item.year} delay={i * 0.06}>
                                <li data-testid={`timeline-item-${item.year}`} className="relative pb-12 pl-10 last:pb-0">
                                    <span className="absolute -left-[7px] top-1.5 h-3.5 w-3.5 border-2 border-sky-400 bg-navy-950" />
                                    <span className="font-mono text-sm font-bold tracking-[0.25em] text-sky-400">
                                        {item.year}
                                    </span>
                                    <h3 className="mt-2 font-display text-xl font-semibold text-slate-50 sm:text-2xl">
                                        {item.title}
                                    </h3>
                                    <p className="mt-2 max-w-xl text-sm leading-relaxed text-slate-400 sm:text-base">
                                        {item.desc}
                                    </p>
                                </li>
                            </Reveal>
                        ))}
                    </ol>

                    <div className="space-y-6">
                        <Reveal delay={0.1}>
                            <div data-testid="ctu-card" className="border border-navy-600 bg-navy-950 p-6 sm:p-8">
                                <Scale className="h-5 w-5 text-sky-400" />
                                <p className="mt-5 font-mono text-[11px] uppercase tracking-[0.25em] text-slate-500">
                                    {t.experience.ctu.label}
                                </p>
                                <h3 className="mt-2 font-display text-xl font-semibold text-slate-50">
                                    {t.experience.ctu.title}
                                </h3>
                                <p className="mt-3 text-sm leading-relaxed text-slate-400">
                                    {t.experience.ctu.text}
                                </p>
                            </div>
                        </Reveal>
                        <Reveal delay={0.18}>
                            <div data-testid="software-card" className="border border-navy-600 bg-navy-950 p-6 sm:p-8">
                                <Code2 className="h-5 w-5 text-sky-400" />
                                <h3 className="mt-5 font-display text-xl font-semibold text-slate-50">
                                    {t.experience.software.title}
                                </h3>
                                <p className="mt-3 text-sm leading-relaxed text-slate-400">
                                    {t.experience.software.text}
                                </p>
                                <div className="mt-4 flex flex-wrap gap-2">
                                    {t.experience.software.tags.map((p) => (
                                        <span
                                            key={p}
                                            className="border border-navy-600 px-2.5 py-1 font-mono text-[10px] uppercase tracking-widest text-slate-400"
                                        >
                                            {p}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </Reveal>
                    </div>
                </div>
            </div>
        </section>
    );
}
